import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, LineChart, CartesianGrid, Legend, Line } from 'recharts';

// Sample data: Replace with your actual poll data
const data = [
  { name: 'Option 1', count: 50 },
  { name: 'Option 2', count: 20 },
  { name: 'Option 3', count: 30 },
  { name: 'Option 4', count: 90 },
  { name: 'Option 5', count: 120 },
  { name: 'Option 6', count: 10 },
];
const data2 = [
  {
    "name": "Page A",
    "uv": 4000,
    "pv": 2400,
    "amt": 2400
  },
  {
    "name": "Page B",
    "uv": 3000,
    "pv": 1398,
    "amt": 2210
  },
  {
    "name": "Page C",
    "uv": 2000,
    "pv": 9800,
    "amt": 2290
  },
  {
    "name": "Page D",
    "uv": 2780,
    "pv": 3908,
    "amt": 2000
  },
  {
    "name": "Page E",
    "uv": 1890,
    "pv": 4800,
    "amt": 2181
  },
  {
    "name": "Page F",
    "uv": 2390,
    "pv": 3800,
    "amt": 2500
  },
  {
    "name": "Page G",
    "uv": 3490,
    "pv": 4300,
    "amt": 2100
  }]
const ReportChart = ({mapType}) => {
  return (
    <>
    {(mapType === 'bar') ? (
      <BarChart width={550} height={300} data={data}>
        <Bar dataKey="count" fill="#8884d8" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
      </BarChart>
    ):(
      <LineChart width={550} height={300} data={data2}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="pv" stroke="#8884d8" />
        <Line type="monotone" dataKey="uv" stroke="#82ca9d" />
      </LineChart>
    )}
    </>
  );
};

export default ReportChart;
